import { useCallback } from "react";
import moment from "moment-timezone";
import {
  STANDARD_APP_DATE_FORMAT,
  STANDARD_APP_DATE_TIME_FORMAT,
} from "../constants/constants";
import { useAuth } from "../contexts/AuthProvider";

type FormatOptions = {
  format?: string;
  keepLocalTime?: boolean;
};

export const useTimezoneFormatter = () => {
  // Format a date string in the given timezone
  // (default: converts to timezone)*/

  const { company_outlet_timezone } = useAuth();

  const ftDate = useCallback(
    (date: string | Date, fmt = STANDARD_APP_DATE_FORMAT) => {
      return date && moment(date).isValid() ? moment(date)?.tz(company_outlet_timezone)?.format(fmt) : "N/A";
    },
    [company_outlet_timezone],
  );

  const ftDateCustom = useCallback((date: string | Date, inputFmt = "YYYY-MM-DD", outFmt = STANDARD_APP_DATE_FORMAT) => {
    return moment(date, inputFmt)?.tz(company_outlet_timezone)?.format(outFmt);
  },
    [company_outlet_timezone],
  );

  const ftDateTime = useCallback(
    (date: string | Date, fmt = STANDARD_APP_DATE_TIME_FORMAT) => {
      return moment(date)?.tz(company_outlet_timezone)?.format(fmt);
    },
    [company_outlet_timezone],
  );

  // Keep the same clock time, just change company_outlet_timezone*/
  const formatKeepLocal = useCallback(
    (date: string | Date, fmt = "YYYY-MM-DD HH:mm") => {
      return moment(date)?.tz(company_outlet_timezone, true)?.format(fmt);
    },
    [company_outlet_timezone],
  );

  // Convert to ISO string in company_outlet_timezone*/
  const toISO = useCallback(
    (date: string | Date, keepLocalTime = false) => {
      return keepLocalTime
        ? moment(date)?.tz(company_outlet_timezone, true)?.format()
        : moment(date)?.tz(company_outlet_timezone)?.format();
    },
    [company_outlet_timezone],
  );

  return {
    ftDate,
    ftDateTime,
    formatKeepLocal,
    toISO,
    ftDateCustom
  };
};
